/**
 * @file Drop absence
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { DropBase } from './drop-base';
var AbsenceDrop = /** @class */ (function (_super) {
    tslib_1.__extends(AbsenceDrop, _super);
    /**
     * Creates an instance of AbsenceDrop.
     */
    function AbsenceDrop(domainService, overlayService, dropTargetsService, dialogService, translateService, userService, resourceService) {
        return _super.call(this, 'absence-drop', 'APP.EXECUTORS.ABSENCE_DROP_NAME', ['Absence'], 'Absence', domainService, overlayService, dropTargetsService, dialogService, translateService, userService, resourceService) || this;
    }
    /**
     * The business logic for this executor and is executed after the
     * validation step and before the finish step.
     *
     * @param {ExecutorData} data The executor data
     * @returns {Promise<any>}
     */
    AbsenceDrop.prototype.process = function (data) {
        var _this = this;
        var createEntities = [];
        this.explodeExecutorData(data).forEach(function (slice) {
            createEntities.push(_this.createAbsence(slice.item, slice.target, slice.resource));
        });
        return this.runPromisesParallelAndSave(createEntities);
    };
    /**
     * Create an Absence entity
     * @param {Entity} item
     * @param {ExecutorTimeslot} target
     * @param {Entity[]} resources
     * @returns {Promise<any>}
     */
    AbsenceDrop.prototype.createAbsence = function (item, target, resource) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var entity = _this.domainService.getEntityType('Appointment').createEntity({
                Name: item['Name'],
                Start: target.start,
                Finish: target.finish,
                Concerns_Oid: item['Oid'],
                Color: item['Color'],
                SumFactor: item['SumFactor']
            });
            _this.domainService.addEntity(entity);
            _this.domainService.setDefaultValues(_this.userService.user, entity);
            entity['Resource_Oid'] = resource['Oid'];
            entity['Start'] = target.start.toDate();
            entity['Finish'] = target.finish.toDate();
            resolve(true);
        });
    };
    return AbsenceDrop;
}(DropBase));
export { AbsenceDrop };
